// To run locally use local host, for deployment use backend url
// export const BASE_URL= 'http://localhost:4000/api/v1';  
export const BASE_URL= 'https://horizonbackend.onrender.com/api/v1';
